import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Import translation files
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';
import faTranslations from './locales/fa.json';

// Language configuration
const languages = {
  en: { 
    name: 'English', 
    dir: 'ltr',
    flag: '🇺🇸'
  },
  ar: { 
    name: 'العربية', 
    dir: 'rtl',
    flag: '🇸🇦'
  },
  fa: { 
    name: 'فارسی', 
    dir: 'rtl',
    flag: '🇮🇷'
  }
};

// Initialize i18n
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Default language
    lng: 'en',
    fallbackLng: 'en',
    
    // Debug mode (set to false in production)
    debug: process.env.NODE_ENV === 'development',
    
    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'lumen-smile-language',
    },
    
    // Resources (embedded translations)
    resources: {
      en: {
        translation: enTranslations
      },
      ar: {
        translation: arTranslations
      },
      fa: {
        translation: faTranslations
      }
    },
    
    // Backend options for loading translations from server
    backend: {
      loadPath: '/locales/{{lng}}.json',
      addPath: '/locales/{{lng}}/{{ns}}',
    },
    
    // React options
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em', 'span'],
    },
    
    // Namespace
    ns: ['translation'],
    defaultNS: 'translation',
  });

// Function to get language info
export const getLanguageInfo = (langCode) => {
  return languages[langCode] || languages.en;
};

// Function to get all available languages
export const getAvailableLanguages = () => {
  return Object.keys(languages).map(code => ({
    code,
    ...languages[code]
  }));
};

// Function to change language and update document direction
export const changeLanguage = (langCode) => {
  i18n.changeLanguage(langCode);
  const langInfo = getLanguageInfo(langCode);
  document.documentElement.dir = langInfo.dir;
  document.documentElement.lang = langCode;
  localStorage.setItem('lumen-smile-language', langCode);
};

// Set initial direction
const currentLang = i18n.language || 'en';
const langInfo = getLanguageInfo(currentLang);
document.documentElement.dir = langInfo.dir;
document.documentElement.lang = currentLang;

export default i18n; 